export const increment = ({ dispatch }) => {
  dispatch('INCREMENT')
}

export const pushModal = ({commit}, {component, props, fullscreen}) => {
  commit('pushModal', {component, props, fullscreen})
}

export const popModal = ({commit}) => {
  commit('popModal')
}

export default {
  pushModal,
  popModal
}